import React, { useState, useEffect } from "react"
import { Card, CardBody, CardTitle, Button } from "reactstrap"
import queryString from "query-string"

import OkDialog from "../../Pages/OkDialog"
import LoadingOrErrorCard from "../LoadingOrErrorCard/LoadingOrErrorCard"
import "./fractalKYC.scss"

const NFTPrefs = {
    // frontendServer: "https://next.fractal.id", // not working- old from bloxmove
    // frontendServer: "https://app.next.fractal.id", // not working- staging
    // resourceServer: "https://resource.next.fractal.id", // staging
    // authServer: "https://auth.next.fractal.id", // staging
    // scope: "contact%3Aread%20verification.plus%3Aread%20verification.plus.details%3Aread%20verification.liveness%3Aread%20verification.liveness.details%3Aread", // plus verification for institutions
    frontendServer: "https://app.fractal.id", // production
    resourceServer: "https://resource.fractal.id", // production
    authServer: "https://auth.fractal.id", // production
    scope: "contact:read verification.basic:read verification.basic.details:read verification.liveness:read verification.liveness.details:read", // basic not available for institutions
    // redirectUri: "https%3A%2F%2Fapp.idexo.io%2Ftokengating" // https://app.idexo.io/tokengating // production
    redirectUri: "https://app.idexo.io/tokengating" // production
}

const parts = window.location.hostname.split(".") // ['swordsofblood', 'idexo', 'com'], ['localhost'], or ['app', 'idexo', 'io']
const subdomain = parts[0] // 'swordsofblood', 'localhost', 'app'
// const subdomain = "swordsofblood"
// const subdomain = "app"
// NOTE: for testing dynamic text rendering, change the subdomain value above

const userUrl = `${NFTPrefs.resourceServer}/users/me`

const FractalKYC = (props) => {
    const { networkOptionStatus, validationStatus } = props
    const [kycProcessed, setKycProcessed] = useState(false)
    const [verificationCases, setVerifications] = useState([])
    const [dialogOpen, setDialog] = useState(false)
    const [showKYCLoading, setShowKYCLoading] = useState(true) // loading spinner animation for checking user KYC status OR getting refresh/access token
    const [kycStatus, setKycStatus] = useState("Not Started") // "Not Started" -> "pending" -> "done"

    const handleClickLogIn = (e) => {
        let refreshToken = localStorage.getItem("refreshToken")
        if (refreshToken && refreshToken !== "undefined") {
            return refreshProcess(refreshToken)

            // Validated if user has 1) any idexo staking NFTs or 2) idexo Early Adopter NFTs, or a subdomain collection holder (ex. swords of blood)
            // TO DO: backend webhook- user validation to check if user can proceed with fractal kyc (ex. if they meet any of the 3 conditions above)
        } else if (validationStatus === "Validated") {
            const redirectUri = subdomain === "app" ? NFTPrefs.redirectUri : "https://swordsofblood.idexo.com/tokengating" // NOTE* this will need to change if we have other clients that do KYC
            const authUrl = `${NFTPrefs.frontendServer}/authorize?client_id=${process.env.REACT_APP_FRACTAL_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=code&scope=${NFTPrefs.scope}`
            window.open(authUrl, "_self")
        } else {
            setDialog(true)
        }
    }

    const refreshProcess = (refreshToken) => {
        return fetch("https://fractaloauth.idexo.io", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            body: JSON.stringify({
                refresh_token: refreshToken
            })
        })
            .then((res) => res.json())
            .then((res) => {
                localStorage.setItem("accessToken", res.data.access_token)
                localStorage.setItem("refreshToken", res.data.refresh_token)
                return getUser(res.data.access_token)
            })
            .catch((err) => {
                console.log(err)
                setShowKYCLoading(false)
            })
    }

    const getUser = (accessToken) => {
        return fetch(userUrl, {
            method: "GET",
            headers: { Authorization: `Bearer ${accessToken}` }
        })
            .then((res) => res.json())
            .then((res) => {
                setKycProcessed(true)
                setVerifications(res.verification_cases)
                let status = res.verification_cases.length === 0 ? kycStatus : res.verification_cases[0].status
                setKycStatus(status)
                setShowKYCLoading(false)
            })
            .catch((err) => {
                console.log(err)
                setShowKYCLoading(false)
            })
    }

    const loginProcess = (code, redirect_uri) => {
        fetch("https://fractaloauth.idexo.io", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            body: JSON.stringify({
                code: code,
                redirect_uri: redirect_uri
            })
        })
            .then((res) => res.json())
            .then((res) => {
                localStorage.setItem("accessToken", res.data.access_token)
                localStorage.setItem("refreshToken", res.data.refresh_token) // if res.data.refresh_token is undefined, we will be adding the string "undefined" to localStorage
                return getUser(res.data.access_token)
            })
            .catch((err) => {
                console.log(err)
                setShowKYCLoading(false)
            })
    }

    useEffect(() => {
        ;(async () => {
            let refreshToken = localStorage.getItem("refreshToken")
            if (refreshToken && refreshToken !== "undefined") {
                return refreshProcess(refreshToken)
            } else if (!kycProcessed) {
                const { code } = queryString.parse(window.location.search)
                // - code = undefined if no queryParams, otherwise {param:value, ...}
                // - code represents Fractal Authorization code to be exchanged for an access token, expiring in 10 minutes
                if (code) {
                    try {
                        const redirectUri = subdomain === "app" ? NFTPrefs.redirectUri : "https://swordsofblood.idexo.com/tokengating" // NOTE* this will need to change if we have other clients that do KYC
                        return loginProcess(code, redirectUri)
                    } catch (error) {
                        console.error(error)
                    }
                }
                setShowKYCLoading(false)
            }
        })()
    }, [kycProcessed])

    return (
        <Card className="fractal-kyc-wrap">
            <CardBody>
                <CardTitle className="h3">Fractal KYC</CardTitle>

                {showKYCLoading ? (
                    <LoadingOrErrorCard loadingTxt={"Your KYC Status"} className="kyc-loading" />
                ) : (
                    <React.Fragment>
                        <div className="kyc-status-info-wrap">
                            <span className="kyc-label">KYC Status:</span> <span>{kycStatus}</span>
                        </div>

                        {kycStatus === "done" ? (
                            <div>Congratulations! Your KYC process is complete and verification is approved!</div>
                        ) : (
                            <Button color="light" className="fractal-id-btn" onClick={handleClickLogIn}>
                                Log in with <span style={{ color: "#EE7326" }}>Fractal</span>
                            </Button>
                        )}
                    </React.Fragment>
                )}
            </CardBody>

            <OkDialog open={dialogOpen} title={""} message={"Sorry we can not detect a valid NFT."} okClick={() => setDialog(false)} />
        </Card>
    )
}

export default FractalKYC
